// extracted by mini-css-extract-plugin
export default {"unique-org-grid":"aGrSKU8CGUyQmP7k5UgM","for-you-org-grid":"O7NiRtgIKQN7e50IYXnE"};